// extracted by mini-css-extract-plugin
module.exports = {"consecSelectWidth":"RulesTableData_consecSelectWidth__3Mivr","green":"RulesTableData_green__ye4dP","black":"RulesTableData_black__gHBLI"};